import React from "react"
import { useWallet } from "../hooks/use-wallet"

export const withWallet = (Component) => {
  return (props) => {
    const walletProps = useWallet()

    return <Component wallet={walletProps} {...props} />
  }
}
